import $ from 'jquery';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import _ from 'lodash-es';
import allSlidesVisible from './allSlidesVisible';

export default function(container = document, new_slides, new_slides_target) {
  $('[data-simple-carousel]', container).each((i, carousel) => {
    console.log('carousel:', carousel);
    const $carousel = $(carousel);
    let id = $carousel.attr('id');
    let $slides = $carousel.find('[data-slide]');
    const min_slides = $carousel.data('minSlides') || 2;
    const dynamic_min_slides = $carousel.data('dynamicMinSlides') || false;
    $carousel.attr('data-carousel-index', i);
    // let all_slides_visible;
    let initial_index;

    if (!id) {
      const random = Math.round(Math.random() * 100000);
      id = `SimpleCarousel--auto${random}`;
      $carousel.attr('id', id);
    }

    if (window.theme.carousels[id]) {
      initial_index = window.theme.carousels[id].selectedIndex;
      window.theme.carousels[id].destroy();
      delete window.theme.carousels[id];
    }

    if (new_slides && new_slides_target) {
      $slides.remove();
      $(new_slides_target).append(new_slides);
      $slides = $carousel.find('[data-slide]');
    }

    if ($slides.length < 2) { return; }

    if (dynamic_min_slides) {
      if (allSlidesVisible($carousel)) { return; }
    } else if ($slides.length < min_slides) {
      return;
    }

    let carousel_options = {};
    let carousel_properties = [
      {
        name: 'initialIndex',
        default: 0,
      },
      {
        name: 'prevNextButtons',
        default: true,
      },
      {
        name: 'pageDots',
        default: true,
      },
      {
        name: 'wrapAround',
        default: true,
      },
      {
        name: 'cellAlign',
        default: 'center',
      },
      {
        name: 'contain',
        default: false,
      },
      {
        name: 'adaptiveHeight',
        default: true,
      },
      {
        name: 'imagesLoaded',
        default: true,
      },
      {
        name: 'draggable',
        default: true,
      },
    ];

    _.each(carousel_properties, (property) => {
      // this syntax allows you to assign a value of false
      carousel_options[property.name] = $carousel.data(property.name);

      if (carousel_options[property.name] === undefined) {
        carousel_options[property.name] = property.default;
      }
    });

    // if (all_slides_visible) {
    //   // make carousel static if set to dynamic min slides and all products are visible
    //   carousel_options.wrap_around = false;
    //   carousel_options.prev_next_buttons = false;
    //   carousel_options.draggable = false;
    //   carousel_options.cell_align = 'center';
    // }

    if (initial_index) {
      carousel_options.initial_index = initial_index;
    }

    carousel_options.on = {
      ready: () => {
        $carousel.addClass('AnimateOnLoad--loaded');
      },
    };

    const fl_carousel = new Flickity($carousel[0], carousel_options);

    window.theme.carousels[id] = fl_carousel;
    $carousel.trigger('carouselAvailable');
  });
}